module.exports = __webpack_public_path__ + "media/images/flags/32/Kyrgyzstan-c7a5a42a321999f33fd3e7224358622f.png";